import { ProjectIssuanceSpecificSchema } from "../../../models";

/*
  `getStandardSpecificSchemaDetails` types `issuanceSchema` as `any` and the API returns it either as an
  object or as a JSON string, so every caller has to normalise it before reading `.properties` - reading the
  raw value silently yields no properties when it arrives as a string.
*/
export const parseIssuanceSchema = (issuanceSchema: unknown): ProjectIssuanceSpecificSchema | undefined => {
  if (issuanceSchema == null) return undefined;

  try {
    const parsedSchema =
      typeof issuanceSchema === "string"
        ? (JSON.parse(issuanceSchema) as ProjectIssuanceSpecificSchema)
        : (issuanceSchema as ProjectIssuanceSpecificSchema);

    return parsedSchema?.properties ? parsedSchema : undefined;
  } catch {
    return undefined;
  }
};
